import { SimNaoEnum } from 'components/form'
import { intervalToDuration } from 'date-fns'
import { MChatPerguntaEnum, MChatRiscoEnum } from 'graphql/types.generated'

import {
  MChatAplicacaoModel,
  MChatFieldModel,
  MChatRiscoPrevioRelevanteInfoModel,
  RegistroMChatQueryModel,
} from './model-mchat'

export const PERGUNTAS_RISCO_SIM = [
  MChatPerguntaEnum.PERGUNTA_02,
  MChatPerguntaEnum.PERGUNTA_05,
  MChatPerguntaEnum.PERGUNTA_12,
]

export const PERGUNTAS_RISCO_NAO = Object.values(MChatPerguntaEnum).filter(
  (pergunta) => !PERGUNTAS_RISCO_SIM.includes(pergunta)
)

export function isMChatPerguntaFalha(pergunta: MChatPerguntaEnum, resposta: SimNaoEnum): boolean {
  return (
    (PERGUNTAS_RISCO_SIM.includes(pergunta) && resposta === SimNaoEnum.SIM) ||
    (PERGUNTAS_RISCO_NAO.includes(pergunta) && resposta === SimNaoEnum.NAO)
  )
}

export function getMChatPerguntaNumber(pergunta: MChatPerguntaEnum): number {
  if (!pergunta) return null
  const number = pergunta.split('PERGUNTA_')[1]
  return Number(number)
}

export function calcularResultadoMChat(aplicacao: MChatAplicacaoModel): MChatFieldModel {
  let risco: MChatRiscoEnum = null
  let resultado: number = 0

  Object.entries(aplicacao).forEach(([pergunta, resposta]: [MChatPerguntaEnum, SimNaoEnum]) => {
    if (isMChatPerguntaFalha(pergunta, resposta)) {
      resultado += 1
    }
  })

  if (resultado >= 8) {
    risco = MChatRiscoEnum.ELEVADO
  } else if (resultado >= 3) {
    risco = MChatRiscoEnum.MEDIO
  } else {
    risco = MChatRiscoEnum.BAIXO
  }

  return {
    aplicacao,
    resultado,
    risco,
  }
}

export function getMChatAplicacaoPerguntasFalhas(aplicacao: MChatAplicacaoModel): MChatPerguntaEnum[] {
  if (!aplicacao) return []

  const perguntasFalhas = []

  Object.entries(aplicacao).forEach(([pergunta, resposta]: [MChatPerguntaEnum, SimNaoEnum]) => {
    if (isMChatPerguntaFalha(pergunta, resposta)) {
      perguntasFalhas.push(pergunta)
    }
  })

  const sorted = [...perguntasFalhas].sort((a, b) => a.localeCompare(b))
  return sorted
}

export function getAlertaMChatAnterior(
  riscoAtual: MChatRiscoEnum,
  registrosMChat: RegistroMChatQueryModel[] = []
): MChatRiscoPrevioRelevanteInfoModel {
  if (!riscoAtual) return null

  const registrosMchat = registrosMChat.filter((registro) => registro.isMchatRf === false)

  const ultimoRiscoElevado = registrosMchat
    .filter((r) => r.risco === MChatRiscoEnum.ELEVADO)
    .sort((a, b) => new Date(b.dataResultado).getTime() - new Date(a.dataResultado).getTime())
    .first()

  const ultimoRiscoMedio = registrosMchat
    .filter((r) => r.risco === MChatRiscoEnum.MEDIO)
    .sort((a, b) => new Date(b.dataResultado).getTime() - new Date(a.dataResultado).getTime())
    .first()

  if (ultimoRiscoElevado && (riscoAtual === MChatRiscoEnum.BAIXO || riscoAtual === MChatRiscoEnum.MEDIO)) {
    return {
      risco: MChatRiscoEnum.ELEVADO,
      duracaoDesdeRiscoPrevio: intervalToDuration({
        start: new Date(ultimoRiscoElevado.dataResultado),
        end: new Date(),
      }),
    }
  }

  if (ultimoRiscoMedio && riscoAtual === MChatRiscoEnum.BAIXO) {
    return {
      risco: MChatRiscoEnum.MEDIO,
      duracaoDesdeRiscoPrevio: intervalToDuration({
        start: new Date(ultimoRiscoMedio.dataResultado),
        end: new Date(),
      }),
    }
  }

  return null
}
